import { ElementRef, Inject, OnDestroy, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TemplatesService } from '../templates/templates.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AddProposalService } from '../proposals/add-proposal/add-proposal.service';

@Component({
  selector: 'app-template-upload-modal',
  templateUrl: './template-upload-modal.component.html',
  styleUrls: ['./template-upload-modal.component.css']
})
export class TemplateUploadModalComponent implements OnInit, OnDestroy {
  @ViewChild('file', { static: false }) fileInput: ElementRef<HTMLInputElement>;

  fileSizeError: string = '';

  constructor(public dialogRef: MatDialogRef<TemplateUploadModalComponent>, private dialog: MatDialog, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _templateService: TemplatesService,
    private _proposalService: AddProposalService,
    private toastr: ToastrService) {

  }
  private unsubscribe = new Subject<void>();
  selectedFileNames: string[] = [];
  showAlert: boolean;
  alertMessage: string;
  showCategory: boolean = false;
  hasUploadClicked: boolean = false;
  certificateUpload: boolean = false;
  subCategories: any = [];
  competencies: any = [];
  subCompetencies: any = [];
  selectedCategory: number = 0;
  public selectedFiles: any = [];
  requestData: any = [];
  description: string;
  subcategory: any = [];
  template: any = [];
  subTemplate: any = [];
  dropdowns: Dropdown[] = [];
  optionarray = [];

  isFileRangeExceeded: boolean = false;
  Files = new UntypedFormControl();
  formData = FormGroup;
  ngOnInit() {
    this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialogRef.close();
      }
    });
    this.showAlert = false;
    if (this.data && this.data.categoryTypes) {
      this.showCategory = true;
    }
    if (this.data && this.data.certificateCategoryTypes) {
      this.certificateUpload = true;
    }

  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  onFileChange(data) {
    this.fileSizeError = '';
    this.optionarray = this.data.certificateCategoryTypes;
    var x = Array.from(data);
    x = [...new Set(x)];

    x.forEach(async (element: File) => {
      if (element.size > 20000000) { 
        this.fileSizeError = 'File exceeded size limit';
        return;
      }

      const dropdown = new Dropdown(this.optionarray);
      this.dropdowns.push(dropdown);
      // if (this.selectedFiles.length > 4) {
      //   this.toastr.error("You can only upload a maximum of 4 files.");
      //   return;
      // }
      if (this.isFileSelected(element)) {
        this.toastr.warning("This file is already selected.");
        return;
      }

      let processedFile = await Promise.resolve(this.convertFile(element));
      const extension = element.name.split('.').pop();
      let extensionTypes = ['.pdf', '.doc', '.docx'];
      if (!extensionTypes.includes(`.${extension}`)) {
        this.toastr.error("Only pdf, doc, and docx file types are allowed.");
        return;
      }

      element['dropdown'] = dropdown;
      this.selectedFiles.push(element);
      this.addSelectedFile(element);
      this.requestData.push({
        CategoryId: 0,
        SubCategoryTemplate: 0,
        templateDescription: '',
        Name: element.name,
        isValidFileRange: false,
        FileExtension: element.name.split('.').pop(),
        MimeType: element.type,
        FileBase64: processedFile.toString().split(",")[1],
      });
      this.subcategory.push([]);
    });
  }
  uploadFile(data): boolean {


    var x = Array.from(data);
    x = [...new Set(x)];
    x.forEach(async (element: File) => {
      let processedFile = await Promise.resolve(this.convertFile(element))
      const extension = element.name.split('.').pop()
      if (extension !== '.pdf' && extension !== '.doc' && extension !== '.docx') {
        return false;
      }
      else {
        return true
      }

    })


    const allowedExtensions = ['docx', 'doc', 'pdf'];
    const fileExtension = data.name.split('.').pop()?.toLowerCase() || '';

    if (allowedExtensions.includes(fileExtension)) {
      return true
    } else {
      return false
    }
  }
  isFileSelected(file: File): boolean {
    if (this.selectedFileNames.includes(file.name)) {
      return true;
    }
    return false;
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  onSelected(selectedValue: string, dropdown: any, i: number) {
    this.requestData[i].selectedCategory = selectedValue;
    dropdown.selectedOptions = selectedValue;
    if (this.requestData[i].certificateCategorySelected) {
      this.showAlert = false;
      delete this.requestData[i].certificateCategorySelected;
    }

    this.requestData[i].certificateCategory = selectedValue !== "-1" ? selectedValue : null;
  }
  addSelectedFile(file: File): void {
    this.selectedFileNames.push(file.name);
  }
  competencyChange() {
    if (this.selectedCategory) {
      this._proposalService.getSubServiceLines(this.selectedCategory).subscribe((res) => {
        this.subCompetencies = res.data;
      })
    }
  }
  categoryChange(event, file, i) {
    let index = event.target.selectedIndex;
    if (index && this.requestData[i].competencySelected) {
      this.showAlert = false;
      delete this.requestData[i].competencySelected;
    }
    if (index) {
      let value = event.target.value
      this._proposalService.getSubServiceLines(index).subscribe((res) => {
        this.subcategory[i] = res.data;
      })
      this.requestData = this.requestData.map((rd, i) => {
        if (rd.Name == file.name) {
          rd.CategoryId = value
          rd.CategoryName = this.competencies[parseInt(value) - 1].name
        }
        return { ...rd }
      })
    }
  }
  templateChange(event, file, i) {
    let index = event.target.selectedIndex;
    if (index && this.requestData[i].templateIdSelected) {
      this.showAlert = false;
      delete this.requestData[i].templateIdSelected;
    }
    if (index) {
      let value = event.target.value
      this.subTemplate[i] = this.template[i].find(({ id }) => id === index).subCategories;
      this.requestData = this.requestData.map((rd, i) => {
        if (rd.Name == file.name) {
          rd.templateId = value
          let templates = this.template[i]
          rd.templateName = templates[parseInt(value) - 1].category
        }
        return { ...rd }
      })
    }
  }

  certificateCategoryChange(event, file, i) {
    if (this.requestData[i].certificateCategorySelected) {
      this.showAlert = false;
      delete this.requestData[i].certificateCategorySelected;
    }

    this.requestData[i].certificateCategory = event.target.value != "-1" ? event.target.value : null;
  }

  subTemplateChange(event, file, i) {
    let index = event.target.selectedIndex;
    if (index && this.requestData[i].subTemplateSelected) {
      this.showAlert = false;
      delete this.requestData[i].subTemplateSelected;
    }
    if (index) {
      let value = event.target.value
      this.requestData = this.requestData.map((rd, i) => {
        let subTemplate = this.subTemplate[i];
        if (rd.Name == file.name) {
          rd.SubCategoryTemplateId = value;
          rd.SubCategoryTemplate = subTemplate[parseInt(value) - 1].subCategory
        }
        rd.SharepointFolderId = subTemplate[parseInt(value) - 1].sharepointId
        return { ...rd }
      })
    }
  }

  getCompetencies() {
    this._proposalService.getServiceLines().subscribe((res) => {
      this.competencies = res.data;
    })
  }
  getSubCompetencies(id: number) {
    this._proposalService.getSubServiceLines(id).subscribe((res) => {
      this.subcategory = res.data;
    })
  }
  deleteAttachment(file, i) {
    this.selectedFiles = this.selectedFiles.filter(sf => sf.name !== file.name)
    this.requestData = this.requestData.filter(sf => sf.Name !== file.name)
    this.subcategory.splice(i, 1);
    if (this.selectedFileNames.length > 0) {
      var fileName = file.name.toString()
      var index = this.selectedFileNames.indexOf(fileName)
      if (index > -1) {
        this.selectedFileNames.splice(index, 1);

      }
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';

      }
      if (file.size > 20000000) {
        this.isFileRangeExceeded = false;
      }
    }
  }

  changeDescription(event, i) {
    if (this.requestData[i].descriptionSelected) {
      this.showAlert = false;
      delete this.requestData[i].descriptionSelected;
    }
    this.requestData[i].templateDescription = event.target.value;
  }
  convertFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  }
  addTemplates() {

    if (this.requestData.length == 0) {
      this.toastr.error("Upload atleast one document")
      this.hasUploadClicked = true;
      return
    }
    let isInvalidCategory = false;

    // Check if any 'otherCategoryName' field is empty when 'Others' is selected
    this.requestData.forEach((data, index) => {
      if (data.selectedCategory === 'Others' && (!data.otherCategoryName || data.otherCategoryName.trim() === '')) {
        isInvalidCategory = true;
      }
    });
  
    if (isInvalidCategory) {
      // Display toaster message and prevent upload
      this.toastr.error('Please fill in the Category Name for "Others');
      return;
    }
   
    this.requestData.forEach(i => {
      if (i.CategoryId && i.SubCategoryTemplate && i.templateDescription) {
        this.showAlert = false;
        i.subCompetencySelected = false;
        i.competencySelected = false;
        i.descriptionSelected = false;
        i.mimeType = i.MimeType;
        i.FileExtension = i.Name.split('.')[1];
      }
      if (this.showCategory) {
        if (!i.CategoryId) {
          i.competencySelected = true;
          this.showAlert = true;
        }
        if (!i.SubCategoryId) {
          i.subCompetencySelected = true;
          this.showAlert = true;
        }
        if (!i.templateId) {
          i.templateIdSelected = true;
          this.showAlert = true;
        }
        if (!i.SubCategoryTemplate) {
          i.subTemplateSelected = true;
          this.showAlert = true;
        }
      }
      if (!i.templateDescription && !this.certificateUpload) {
        i.descriptionSelected = true;
        this.showAlert = true;
      }
      if (this.certificateUpload && !i.certificateCategory) {
        i.certificateCategorySelected = true;
        this.showAlert = true;
      }
    })
    if (this.requestData.length > 0 && !this.showAlert) {

      this.selectedFiles = []
      this.closeDialog(this.requestData)
    }
    else if (this.showAlert) {
      this.toastr.error("Please fill all required fields");
    }
  }
  closeDialog(status) {
    this.dialogRef.close(status)

  }
  truncateFileName(fileName: string): string {
    const maxLength = 25; // Adjust the max length as needed
    const extensionIndex = fileName.lastIndexOf('.');
    const extension = fileName.substring(extensionIndex);
    const nameWithoutExtension = fileName.substring(0, extensionIndex);

    if (nameWithoutExtension.length + extension.length <= maxLength) {
      return fileName;
    }

    const visibleStart = nameWithoutExtension.substring(0, 10); // Adjust visible start length
    const visibleEnd = nameWithoutExtension.substring(nameWithoutExtension.length - 5); // Adjust visible end length
    return `${visibleStart}...${visibleEnd}${extension}`;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    console.log('Drag Over Event Triggered');
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    console.log('Drag Leave Event Triggered');
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer?.files;
    if (files) {
      this.onFileChange(files);
      console.log('Files Dropped:', files);
    }
  }
}
class Dropdown {
  selectedOptions: string = "Select Category";
  availableOptions: string[] = [];

  constructor(public options: string[]) {
    this.availableOptions = this.options.slice();
  }
}
